import { ContentCopy as CopyIcon } from 'mdi-material-ui';
import React from 'react';
import { useCopyToClipboard } from '../../utils/useCopyToClipboard';
import { IconButton, IconButtonProps } from '../IconButton';

export type CopyToClipboardButtonProps = Omit<
  IconButtonProps,
  | 'onClick'
  | 'form'
  | 'formAction'
  | 'formEncType'
  | 'formMethod'
  | 'formNoValidate'
  | 'formTarget'
  | 'danger'
  | 'Badge'
  | 'type'
  | 'value'
  | 'component'
> & {
  valueToCopy: string;
  innerSx?: IconButtonProps['sx'];
  /** Called after the value is successfully copied to the clipboard. */
  onCopySuccess?: () => void;
  /**
   * Message to display when the value is copied to the clipboard. If not provided, the default message "Copied" will be used.
   */
  successMessage?: string;
};

/**
 * Button that will copy the 'valueToCopy' prop's value to the clipboard when
 * clicked.
 */
export function CopyToClipboardButton({
  valueToCopy,
  onCopySuccess,
  successMessage,
  innerSx,
  variant = 'secondary',
  ...props
}: CopyToClipboardButtonProps) {
  const copy = useCopyToClipboard();

  return (
    <IconButton
      title="copy-to-clipboard"
      variant={variant}
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const success = await copy(valueToCopy, successMessage);
        if (success) {
          onCopySuccess?.();
        }
      }}
      {...props}
    >
      <CopyIcon sx={innerSx} />
    </IconButton>
  );
}
